<template>
  <lf-base-dialog
    v-model="dialogShow"
    :title="isoationstatus === 2 ? '隔离详情' : '隔离操作'"
    :append-to-body="true"
    class="el-dialog--maia ib-form default"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
  >
    <div class="maia-content">
      <template v-if="isoationstatus === 1">
        <el-form
          ref="isoationFormRef"
          class="ib-form"
          label-width="110px"
          :model="isoationForm"
          :rules="rules"
          status-icon
        >
          <el-form-item>
            <p class="alarm-message">
              此操作将使该报警点位暂时被隔离，不会产生新的报警，可至隔离报警中查询及恢复
            </p>
          </el-form-item>
          <el-form-item
            label="隔离原因："
            prop="reason"
          >
            <el-select
              v-model="isoationForm.reason"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in isolationReasonList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="预计恢复时间："
                        prop="expireRecoverTime"
          >
            <el-date-picker
              v-model="isoationForm.expireRecoverTime"
              style="width: 100%;"
              type="date"
              placeholder="选中时间"
            />
          </el-form-item> -->
          <el-form-item
            label="隔离详情"
            prop="detail"
          >
            <el-input
              v-model="isoationForm.detail"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入隔离详情"
              show-word-limit
              maxlength="120"
              clearable
            />
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <el-row v-loading="btnLoading">
          <el-col :span="24">
            <ul class="detail-msg-wrap">
              <li>
                <p>隔离时间：</p>
                <p v-if="isolateDetailData.isolateTime">{{ formatDate(isolateDetailData.isolateTime) }}</p>
              </li>

              <li>
                <p>隔离原因：</p>
                <p>{{ REASON_LIST[isolateDetailData.isolateReason -1 ] }}</p>
              </li>
              <li>
                <p>隔离详情：</p>
                <p>{{ isolateDetailData.isolateDetail }}</p>
              </li>
              <!-- <li>
                <p>预期恢复时间：</p>
                <p v-if="isolateDetailData.expireRecoverTime">
                  {{ formatDate( isolateDetailData.expireRecoverTime ) }}
                </p>
              </li> -->
            </ul>
          </el-col>
        </el-row>
      </template>
    </div>
    <template v-slot:footer>
      <span>
        <el-button
          v-if="isoationstatus === 2"
          @click="close"
        >
          关闭
        </el-button>
        <template v-else>
          <el-button
            @click="close"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            :loading="btnLoading"
            @click="isolationAlarm(isoationFormRef)"
          >
            确认
          </el-button>
        </template>
      </span>
    </template>
  </lf-base-dialog>
</template>
<script setup lang="ts">
  import {
    ref, reactive, watch, onMounted,
  } from 'vue';
  import { ElMessage } from 'element-plus';
  import {
    isolateData, isolateDetail,
  } from '@/api/modules/alarm';
  import type { FormInstance, FormRules } from 'element-plus';
  import { formatDate } from '@/utils/index';
  import { REASON_LIST } from './constants';

  interface RuleForm {
    reason: string
    expireRecoverTime: string
    detail: string
    id:string
  }
  interface DetailData {
    isolateTime: string
    expireRecoverTime: string
    isolateReason: any
    isolateDetail:string
  }
  const emit = defineEmits(['close', 'search']);

  const props = defineProps({
    detail: {
      type: Object,
      default: () => ({}),
    },
    isoationstatus: {
      type: Number,
      default: 1,
    },
  });
  const dialogShow = ref(true);
  const btnLoading = ref(false);
  const isolationReasonList = ref([
    { id: '1', name: '现场改造装修' },
    { id: '2', name: '暂无备品备件' },
    { id: '3', name: '维修周期较长' },
    { id: '4', name: '其他' }]); // 隔离原因列表片
  const isoationForm = reactive<RuleForm>({
    detail: '', reason: '', id: '', expireRecoverTime: '',
  });
  const isolateDetailData = ref<DetailData>({
    isolateTime: '',
    expireRecoverTime: '',
    isolateReason: '',
    isolateDetail: '',
  });
  const close = () => {
    dialogShow.value = false;
    emit('close');
  };
  const isoationFormRef = ref<FormInstance>();
  const rules = reactive<FormRules<RuleForm>>({
    reason: [
      {
        required: true,
        message: '请选择隔离原因',
        trigger: 'change',
      }
    ],
    /*
     * expireRecoverTime: [
     *   {
     *     required: true,
     *     message: '请选择预计恢复时间',
     *     trigger: 'change',
     *   }
     * ],
     */

    detail: [
      { required: true, message: '请输入隔离详情', trigger: 'change' }
    ],
  });

  const isolationAlarm = (formEl: FormInstance | undefined) => {
    if (!formEl) { return; }
    console.log(' props.detail', props.detail);
    formEl.validate((valid: boolean) => {
      if (valid) {
        btnLoading.value = true;
        isoationForm.id = props.detail.id;
        isolateData(isoationForm).then((res) => {
          if (res.code === 0) {
            ElMessage({
              type: 'success',
              message: '隔离成功',
              grouping: true,
            });
            close();
            emit('search');
          } else {
            ElMessage({
              type: 'error',
              message: res.message || '操作失败',
              grouping: true,
            });
          }
        }).catch(() => {
        }).finally(() => {
          btnLoading.value = false;
        });
      }
    });
  };

  onMounted(() => {
    if (props.isoationstatus === 2) {
      btnLoading.value = true;
      isolateDetail({ id: props.detail.id }).then((res) => {
        btnLoading.value = false;
        if (res.code === 0) {
          isolateDetailData.value = res.data;
        }
      }).catch().finally(() => {
        btnLoading.value = false;
      });
    }
  });
</script>
<style lang="scss" scoped>
.detail-msg-wrap {
  max-height: 500px;
  overflow-y: auto;

  li {
    display: flex;
    box-sizing: border-box;
    padding: 3px;
    line-height: 20px;

    p:nth-child(1) {
      flex: 0 0 130px;
      margin-right: 10px;
      text-align: right;
    }

    p:nth-child(2) {
      flex: 1;
      margin-left: 10px;
    }

    >div:nth-child(2) {
      flex: 1;
      margin-left: 10px;
    }

    .copy-btn {
      margin-left: 10px;
      color: #409EFF;
      cursor: pointer;
    }
  }

  .split-line {
    margin: 15px;
    background-color: #ececec;
  }
}
</style>
